import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const file = {
  fetchFilesList: lazyModuleMethod(() => import('./fetchFilesList'), 'default'),
  fetchFile: lazyModuleMethod(() => import('./fetchFile'), 'default'),
  addFile: lazyModuleMethod(() => import('./addFile'), 'default'),
  updateFile: lazyModuleMethod(() => import('./updateFile'), 'default'),
  deleteFile: lazyModuleMethod(() => import('./deleteFile'), 'default'),
}
